var map = {
	"./1.jpg": 7824,
	"./10.jpg": 8841,
	"./11.jpg": 8197,
	"./12.jpg": 8497,
	"./13.jpg": 7362,
	"./14.jpg": 9945,
	"./2.jpg": 1371,
	"./3.jpg": 2429,
	"./4.jpg": 1737,
	"./5.jpg": 1121,
	"./6.jpg": 3477,
	"./7.jpg": 9850,
	"./8.jpg": 8094,
	"./9.jpg": 8138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6821;